import { WorkerProfile } from 'src/DTO/WorkerProfile.type';
import { Document } from 'src/DTO/Document.type';
import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';
import {
  GetWorkerByIdPayload,
  GetWorkerByIdResponse,
  WorkerDataPayLoad,
  GenerateFGDeclarationPDFPayload,
  GenerateFGDeclarationPDFResponse,
  ExpireWorkerPayload,
  ArchiveWorkerPayload,
  UpdateDeclarationPayload,
} from './useWorker.types';
import { Account } from 'src/DTO/Account.type';
import { Contract } from 'src/DTO/Contract.type';

export const useGetWorkers: BaseHookRequest<WorkerProfile[], null> = params => {
  const [{ postRequest }, state] = useApi<WorkerProfile[]>(params);
  const getWorkers = () => {
    return postRequest('/admin/workerProfile');
  };
  return [getWorkers, state];
};

export const useGetWorkerById: BaseHookRequest<GetWorkerByIdResponse, GetWorkerByIdPayload> =
  params => {
    const [{ getRequest }, state] = useApi<GetWorkerByIdResponse>(params);
    const getWorker: BaseRequest<GetWorkerByIdPayload> = details =>
      getRequest<GetWorkerByIdPayload>(`/admin/workerProfile/${details?.variables.id}`);
    return [getWorker, state];
  };

export const useGetWorkerDocuments: BaseHookRequest<Document[], GetWorkerByIdPayload> = params => {
  const [{ getRequest }, state] = useApi<Document[]>(params);
  const getWorker: BaseRequest<GetWorkerByIdPayload> = details =>
    getRequest<GetWorkerByIdPayload>(`/admin/workerProfile/${details?.variables.id}/documents`);
  return [getWorker, state];
};

export const useGetWorkerContracts: BaseHookRequest<Contract[], GetWorkerByIdPayload> = params => {
  const [{ getRequest }, state] = useApi<Contract[]>(params);
  const getWorkerContracts: BaseRequest<GetWorkerByIdPayload> = details =>
    getRequest<GetWorkerByIdPayload>(`/admin/document/workerContracts/${details?.variables.id}`);
  return [getWorkerContracts, state];
};

export const useUpdateWorker: BaseHookRequest<WorkerProfile, WorkerDataPayLoad> = params => {
  const [{ postRequest }, state] = useApi<WorkerProfile>(params);
  const updateWorker: BaseRequest<WorkerDataPayLoad> = details => {
    return details
      ? postRequest<WorkerDataPayLoad>('/admin/workerProfile/update', details.variables)
      : undefined;
  };
  return [updateWorker, state];
};

export const useGetWorkerAccount: BaseHookRequest<Account, GetWorkerByIdPayload> = params => {
  const [{ getRequest }, state] = useApi<Account>(params);
  const getWorkerAccount: BaseRequest<GetWorkerByIdPayload> = details =>
    getRequest<GetWorkerByIdPayload>(`/admin/workerProfile/account/${details?.variables.id}`);
  return [getWorkerAccount, state];
};

export const useGenerateFGDeclaration: BaseHookRequest<
  GenerateFGDeclarationPDFResponse,
  GenerateFGDeclarationPDFPayload
> = params => {
  const [{ postRequest }, state] = useApi<GenerateFGDeclarationPDFResponse>(params);
  const request: BaseRequest<GenerateFGDeclarationPDFPayload> = details => {
    console.log('condigsss');
    return details
      ? postRequest<GenerateFGDeclarationPDFPayload>(
          'admin/workerProfile/foreignDeclaration/generate',
          details.variables,
        )
      : undefined;
  };
  return [request, state];
};

export const useExpireWorkerDocument: BaseHookRequest<undefined, ExpireWorkerPayload> = params => {
  const [{ getRequest }, state] = useApi<undefined>(params);
  const request: BaseRequest<ExpireWorkerPayload> = details =>
    getRequest<ExpireWorkerPayload>(
      `/admin/workerProfile/expire/docs/${details?.variables.workerId}`,
    );
  return [request, state];
};

export const useArchiveWorker: BaseHookRequest<undefined, ArchiveWorkerPayload> = params => {
  const [{ getRequest }, state] = useApi<undefined>(params);
  const request: BaseRequest<ArchiveWorkerPayload> = details =>
    getRequest<ArchiveWorkerPayload>(`/admin/workerProfile/archive/${details?.variables.workerId}`);
  return [request, state];
};

export const useUpdateDeclaration: BaseHookRequest<undefined, UpdateDeclarationPayload> =
  params => {
    const [{ postRequest }, state] = useApi<undefined>(params);
    const updateWorker: BaseRequest<UpdateDeclarationPayload> = details => {
      return details
        ? postRequest<UpdateDeclarationPayload>(
            '/admin/workerProfile/declaration/update',
            details.variables,
          )
        : undefined;
    };
    return [updateWorker, state];
  };

export const useGetDeleteRequests: BaseHookRequest<WorkerProfile[], undefined> = params => {
  const [{ getRequest }, state] = useApi<WorkerProfile[]>(params);
  const getDeleteRequests = () => {
    return getRequest('/admin/workerProfile/delete/requests');
  };
  return [getDeleteRequests, state];
};
